export default __webpack_public_path__ + "static/media/Node.f6d9f3a6.png";